import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate} from 'react-router-dom';
import { Box, Button, Drawer,TextField } from '@mui/material'
import { PdfService, SaveTemplate } from '../../adapter/PdfService';
import { ToastContainer, toast } from 'react-toastify';
import GoBack from '../../components/GoBack';
import CodeEditor from "../../components/CodeEditor";
export default function EditTemplate() {
  let location = useLocation();

    let templateData = location.state.templateData
   const [open, setOpen] = React.useState(false);
   const [src,setsrc] = React.useState("");
   const [html,setHtml] = React.useState(templateData.template)
   const navigate = useNavigate()
    const getHtml = (html) => {
         setHtml(html)
    }
  const previewPDf = () =>  {
   PdfService({html:html})
   .then((response) => {
      if(response.status === 200) {
       setOpen(true)
       const byteCharacters = atob(response.data.data);
       const byteNumbers = new Array(byteCharacters.length);
       for (let i = 0; i < byteCharacters.length; i++) {
           byteNumbers[i] = byteCharacters.charCodeAt(i);
       }
       const byteArray = new Uint8Array(byteNumbers);
       const blob = new Blob([byteArray], { type: 'application/pdf' });
       const url = URL.createObjectURL(blob);
          setsrc(url)
      }
 
   })
   .catch((e)=>{
     // ShowNotification(e?.response?.data?.errors[0], "danger")
   })
  }
   const toggleDrawer = (newOpen) => () => {
     setOpen(newOpen);
   };
    const saveTemplate = () => {
     SaveTemplate({ ...templateData,template:html})
     .then((res)=>{
         if(res.status === 200) {
             toast.success("Save SuccessFully")
             navigate('/app/template')
         }
         else {
            toast.error(res.data.message)
         }
     })
     .catch((e)=>{
        toast.error(e.response.data.error)
     })
    }
 
   return (
     <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
           <h2 style={{ color: "#333", fontWeight: "400" }}>Edit Template</h2>
           <GoBack />
         </div>
     <ToastContainer />
     <div style={{display:"grid",gridTemplateColumns:"auto auto",gap:"1.5em",padding:"1em 0"}}>
         <TextField
           type='text'
           label='Enter Template Name'
           value={templateData.templateName}
            disabled
         >
         </TextField>
         <TextField
           type='text'
           label='Document Type'
           value={templateData.documentType}
            disabled
         >
         </TextField>
         </div>
     <CodeEditor editType={true} html={templateData.template} getHtml={getHtml}/>
     <Button  variant="contained"   sx={{ mt: 2, mb: 2 }} style={{
               background:
                 "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
             }}
             onClick={previewPDf}
   >Preview</Button>
       <Button  variant="contained"   sx={{ mt: 2, mb: 2 }} style={{
               background:
                 "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
                 marginLeft:"1em"
             }}
             onClick={saveTemplate}
   >Save</Button>
    <Drawer open={open} sx={{zIndex:"1203"}} anchor='right' onClose={toggleDrawer(false)}>
       <Box sx={{width:"50vw",color:"#000"}}>
       <iframe style={{width:"100%",height:"100vh"}} src={src}  />
       </Box>
       </Drawer>
 
     </>
  )
}
